module.exports = __webpack_public_path__ + "img/user.85139f2d.svg";